import {
	apiGet,
	type ErrorResponse,
	type FetchResponse,
	getApiUrl,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import type { PartnerAllocationHistoryItem } from "Order/Utilities/partnerAllocationHistory";
import { useQuery } from "@tanstack/react-query";

export const PARTNER_ALLOCATION_HISTORY = "PARTNER_ALLOCATION_HISTORY";

export const getPartnerAllocationHistoryQueryKey = (partnerId: number) => [
	PARTNER_ALLOCATION_HISTORY,
	partnerId,
];

export type GetPartnerAllocationHistoryFetchResponse =
	| FetchResponse<PartnerAllocationHistoryItem[], 200>
	| ErrorResponse;

export const getPartnerAllocationHistoryPath = (partnerId: number) =>
	`/partners/${partnerId}/allocation-history`;

export const getPartnerAllocationHistory = (
	partnerId: number,
	headers = new Headers(),
): Promise<GetPartnerAllocationHistoryFetchResponse> => {
	return apiGet(
		`${getApiUrl()}${getPartnerAllocationHistoryPath(partnerId)}`,
		headers,
		{},
	) as Promise<GetPartnerAllocationHistoryFetchResponse>;
};

export function usePartnerAllocationHistoryQuery(partnerId: number) {
	return useQuery({
		queryKey: getPartnerAllocationHistoryQueryKey(partnerId),
		queryFn: processResponse(() => getPartnerAllocationHistory(partnerId)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!partnerId,
	});
}
